<div class="callback-container">
  <div class="callback-card">
    @if (isLoading) {
      <div class="loading">
        <h2>Completing authentication...</h2>
        <p>Please wait while we complete your login.</p>
      </div>
    }

    @if (!isLoading && !errorMessage) {
      <div class="success">
        <h2>Authentication successful!</h2>
        <p>You will be redirected to the dashboard shortly.</p>
      </div>
    }

    @if (!isLoading && errorMessage) {
      <div class="error">
        <h2>Authentication failed</h2>
        <p>{{ errorMessage }}</p>
        <button data-testid="callback-retry-btn" (click)="retryLogin()" class="retry-button">Try Again</button>
      </div>
    }
  </div>
</div>
